import "./ReassignPatient.styles.scss";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import useOrganizationSettings, {
  getPatientWord,
} from "utils/hooks/organizations/useOrganizationSettings";
import { PatientsDropdown, Button } from "components";
import {
  useCurrentUser,
  useGetOrganizationUsers,
  useReassignPatientToTherapist,
} from "utils/hooks";
import { AssignmentSubmission, Patient } from "types";

type ReassignPatientProps = {
  submission?: AssignmentSubmission;
  patient?: Patient;
  onClose?: () => void;
};

const ReassignPatient = ({
  submission,
  patient,
  onClose,
}: ReassignPatientProps) => {
  const { t } = useTranslation(["common"]);
  const { settings: orgSettings } = useOrganizationSettings();
  const { user } = useCurrentUser();
  const { organizationUsers } = useGetOrganizationUsers({
    organizationId: user?.activeOrganizationId || null,
  });
  const { reassignPatientToTherapist, assigning } =
    useReassignPatientToTherapist({
      submissionId: submission?.uuid,
    });
  const [selectedTherapist, setSelectedTherapist] = useState<{
    value: string;
    label: string;
  } | null>(null);

  const handleAssignToTherapist = async () => {
    if (!selectedTherapist?.value) {
      toast.warn(t("calls_to_action.select_therapist"));
      return;
    }
    const result = await reassignPatientToTherapist({
      therapistId: selectedTherapist.value,
      patientId: patient?.uuid,
    });

    if (result && onClose) onClose();
  };

  return (
    <>
      <div className="reassign__descr">
        {t("patients.reassign_patient_description", {
          patientWord: getPatientWord(orgSettings),
        })}
      </div>
      <div className="reassign__list">
        <PatientsDropdown
          placeholder={t("calls_to_action.choose_label")}
          patientsList={organizationUsers}
          onChange={(t) => setSelectedTherapist(t)}
        />
      </div>
      <Button
        name="reassign-patient-to-therapist-btn"
        value={"Assign"}
        extraClass="pill thin reassign__btn"
        disabled={!selectedTherapist}
        onClick={handleAssignToTherapist}
        isLoading={assigning}
      />
    </>
  );
};

export default ReassignPatient;
